<template>
  <div>
    <el-skeleton :count="30" :loading="loading" animated>
      <el-container>
        <el-header height="300px" style="margin: 0;padding: 0;">

          <Head></Head>
        </el-header>
        <el-main style="margin: 0;padding: 0;">
          <div class="windowsWidth">
            <!-- 头条 -->
            <div class="c-bd u-m-t-20 u-p-t-20 u-p-b-20 c-w-100 headnew active c-bg-fff">
              <div class="cont">头条</div>
              <div v-for="(item, index) in c9headList" :key="item.tid" class="u-p-r-30 u-p-l-10">
                <div v-if="index === 0" class="u-font-xl c-font-color-c50000 u-font-bold u-text-center">
                  <router-link :to="{ name: 'details', params: { tid: item.tid } }">{{ item.title }}</router-link>
                </div>
                <div v-else class="u-font-xs c-font-color-b22712 u-line-height-30 u-text-center u-p-t-20">
                  <router-link :to="{ name: 'details', params: { tid: item.tid } }">{{ item.title }}</router-link>
                </div>
              </div>
            </div>
            <!-- 跑马灯 + 政协要闻-->
            <el-row :gutter="0" class="u-m-t-20 c-bg-fff">
              <el-col :span="13" class="u-m-t-20">
                <el-carousel height="450px">
                  <el-carousel-item v-for="item in carouselList" :key="item.tid">
                    <el-image :src="item.img" fit="fill" style="width: 100%; "></el-image>
                    <div class="carousel-title">{{ item.title }}</div>
                  </el-carousel-item>
                </el-carousel>
              </el-col>
              <el-col :span="11">
                <div class="u-m-r-20 u-m-l-20 u-m-b-20 u-m-t-15 ">
                  <div v-for="(item, index) in c10HeadList" :key="item.tid">
                    <div v-if="index === 0"
                         class="u-font-xs u-line-overflow u-line-height-35 c-font-color-015293 u-font-bold">
                      <router-link :to="{ name: 'details', params: { tid: item.tid } }">{{ item.title }}</router-link>
                    </div>
                    <div v-else-if="index === 1" class="u-font-xs u-line-overflow u-line-height-35 c-font-color-030202">
                      <router-link :to="{ name: 'details', params: { tid: item.tid } }">{{ item.title }}</router-link>
                    </div>
                  </div>
                  <div class="u-flex u-m-t-5 c-border-b u-height-45">
                    <div class="c-dian"></div>
                    <router-link to='/category/3/10'>
                      <div :class="{ 'c-font-color-909090': moveTabIndex === 1 }"
                           class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor" @mousemove="mousemoveTabs(0)">
                        政协新闻
                      </div>
                    </router-link>
                    <router-link to='/category/3/9'>
                      <div :class="{ 'c-font-color-909090': moveTabIndex === 0 }"
                           class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor" @mousemove="mousemoveTabs(1)">
                        热点新闻
                      </div>
                    </router-link>
                  </div>
                  <div class="table-wrapper u-m-t-10">

                    <el-table v-if="moveTabIndex === 0" :data="tabList" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <div class="u-font-bold u-font-20 u-line-height-50 c-font-color-030202 u-line-clamp-1"><a
                              :href="'/details' + scope.row.tid" target="_blank"> {{ scope.row.title }}</a>
                          </div>
                          <div class="u-font-14 u-line-height-30 u-line-clamp-2 c-font-color-909090">
                            {{ scope.row.summary }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>

                    <el-table v-else :data="tabList" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <span class="u-font-18 u-line-height-53 c-font-color-030202 c-border-b u-line-clamp-1">
                            <router-link :to="{ name: 'details', params: { tid: scope.row.tid } }">
                              {{ scope.row.title }}</router-link>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </div>
              </el-col>
            </el-row>
            <!-- 专栏图片 -->
            <el-row :gutter="0" class="u-m-t-20 c-bg-fff">
              <el-col class="u-m-t-20">
                <el-carousel height="7.5rem">
                  <el-carousel-item v-for="(item, index) in img1List" :key="index">
                    <router-link :to="{ name: 'details', params: { tid: item.href } }">
                      <el-image :src="item.filePath" fit="fill" style="width: 100%; "></el-image>
                    </router-link>
                  </el-carousel-item>
                </el-carousel>
              </el-col>
            </el-row>
            <!-- 通知公告+机关建设+县区政协 -->
            <div class=" u-m-t-20 c-bg-fff">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="u-flex u-m-t-5 c-border-b u-height-45 u-m-l-20">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">通知公告</div>
                  </div>
                  <div class="table-wrapper u-m-t-10 u-m-l-10">
                    <el-table :data="c11HotList" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <span class="u-font-16 u-line-overflow ">
                            <span class="c-dian-img1"></span>
                            <router-link :to="{ name: 'details', params: { tid: scope.row.tid } }">{{
                                scope.row.title
                              }}</router-link>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="u-flex u-m-t-5 c-border-b u-height-45 u-m-l-20">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">机关建设</div>
                  </div>
                  <div class="table-wrapper u-m-t-10">
                    <el-table :data="c12List" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <span class="u-font-16 u-line-overflow">
                            <span class="c-dian-img1"></span>
                            <router-link :to="{ name: 'details', params: { tid: scope.row.tid } }">{{
                                scope.row.title
                              }}</router-link>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="u-flex u-m-t-5 c-border-b u-height-45 u-m-l-20 u-m-r-20">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">县区政协</div>
                  </div>
                  <div class="table-wrapper u-m-t-10 u-m-r-20">
                    <el-table :data="c13List" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <span class="u-font-16 u-line-overflow">
                            <span class="c-dian-img1"></span>
                            <router-link :to="{ name: 'details', params: { tid: scope.row.tid } }">{{
                                scope.row.title
                              }}</router-link>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- 图片新闻 -->
            <div class=" u-m-t-20 c-bg-fff u-p-20">
              <div class="u-flex  c-border-b1 u-height-45 ">
                <div class="c-dian"></div>
                <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">图片新闻</div>
              </div>
              <el-row :gutter="20" class="u-m-t-20">
                <el-col :span="12">
                  <el-image :src="c15List[0].imagePath || ''" fit="fill"
                            style="width: 100%;height: 450px;"></el-image>
                </el-col>
                <el-col :span="6">
                  <el-image :src="c15List[1].imagePath" fit="fill" style="width: 100%;height: 215px;"></el-image>
                  <el-image :src="c15List[2].imagePath" fit="fill"
                            style="width: 100%;height: 215px;margin-top: 15px;"></el-image>
                </el-col>
                <el-col :span="6">
                  <el-image :src="c15List[3].imagePath" fit="fill" style="width: 100%;height: 215px;"></el-image>
                  <el-image :src="c15List[4].imagePath" fit="fill"
                            style="width: 100%;height: 215px;margin-top: 15px;"></el-image>
                </el-col>
              </el-row>
            </div>
            <!-- 党派团体+学习园地+委员风采 -->
            <div class=" u-m-t-20 c-bg-fff">
              <el-row :gutter="20">
                <el-col :span="8">
                  <div class="u-flex u-m-t-5 c-border-b u-height-45 u-m-l-20">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">党派团体</div>
                  </div>
                  <div class="table-wrapper u-m-t-10 u-m-l-10">
                    <el-table :data="c14List" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <span class="u-font-16 u-line-overflow ">
                            <span class="c-dian-img1"></span>
                            <router-link :to="{ name: 'details', params: { tid: scope.row.tid } }">{{
                                scope.row.title
                              }}</router-link>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="u-flex u-m-t-5 c-border-b u-height-45 u-m-l-20">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">学习园地</div>
                  </div>
                  <div class="table-wrapper u-m-t-10">
                    <el-table :data="cid6List" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <span class="u-font-16 u-line-overflow">
                            <span class="c-dian-img1"></span>
                            <router-link :to="{ name: 'details', params: { tid: scope.row.tid } }">{{
                                scope.row.title
                              }}</router-link>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="u-flex u-m-t-5 c-border-b u-height-45 u-m-l-20 u-m-r-20">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">委员风采</div>
                  </div>
                  <div class="table-wrapper u-m-t-10 u-m-r-20">
                    <el-table :data="c23List" :show-header="false" style="width: 100%">
                      <el-table-column>
                        <template slot-scope="scope">
                          <span class="u-font-16 u-line-overflow">
                            <span class="c-dian-img1"></span>
                            <router-link :to="{ name: 'details', params: { tid: scope.row.tid } }">{{
                                scope.row.title
                              }}</router-link>
                          </span>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- 白银市政协智慧云平台 -->
            <div class="u-flex u-row-evenly u-m-t-20 c-bg-fff u-p-t-10 u-p-b-10">
              <div v-for="(item, index) in img2List" :key="index" class="u-p-l-10 u-p-r-10">
                <a :href="item.href" target="_blank">
                  <el-image :src="item.filePath" fit="fill" style="width: 100%;height: 100px;"></el-image>
                </a>
              </div>
            </div>
            <!-- 杂志+文史资料 -->
            <div class="u-m-t-0 c-bg-fff u-p-20" @mouseout="closeLink">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="u-flex  c-border-b1 u-height-45 ">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">杂志</div>
                  </div>
                  <div class="carousel-wrapper">
                    <el-carousel :interval="4000" class="u-m-t-20" height="250px" type="card">
                      <el-carousel-item v-for="item in c27List" :key="item.tid" :label="item.title">
                        <el-image :src="item.img || ''" fit="contain" style="width:100%;height: 250px;"></el-image>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </el-col>
                <el-col :span="12">
                  <div class="u-flex  c-border-b1 u-height-45 ">
                    <div class="c-dian"></div>
                    <div class="u-font-xx u-font-bold u-p-l-10 u-p-r-10 u-cursor">文史资料</div>
                  </div>
                  <div class="carousel-wrapper">
                    <el-carousel :interval="4000" class="u-m-t-20" height="250px" type="card">
                      <el-carousel-item v-for="item in c28List" :key="item.tid" :label="item.title">
                        <el-image :src="item.img || ''" fit="contain" style="width:100%;height: 250px;"></el-image>
                      </el-carousel-item>
                    </el-carousel>
                  </div>
                </el-col>
              </el-row>
            </div>
            <!-- end -->
          </div>
          <!-- 友情链接 -->

          <div class=" c-bg-757575 u-m-t-30">
            <transition name="el-zoom-in-bottom">
              <div v-if="showLink" ref="linkBox" :style="'top:' + linkTop + 'px'" class="t-link">
                <div class="windowsWidth u-p-20 ">
                  <el-row :gutter="20">
                    <el-col v-for="(item, index) in linkList" :key="index" :span="4"
                            class="c-font-color-ffffff u-line-height-30">
                      <a :href="item.value" target="_blank">{{ item.label }}</a>
                    </el-col>

                  </el-row>
                </div>
              </div>
            </transition>
            <div class="windowsWidth u-height-42 ">
              <div class="u-line-height-40 u-flex u-row-evenly c-font-color-ffffff">
                <div>友情链接</div>
                <div class="u-cursor" @mousemove="mousemoveLinkTabs($event, 3)">
                  省级政协网站
                  <i class="el-icon-caret-top"></i>
                </div>
                <div class="u-cursor" @mousemove="mousemoveLinkTabs($event, 2)">
                  市直属单位网站
                  <i class="el-icon-caret-top"></i>
                </div>
                <div class="u-cursor" @mousemove="mousemoveLinkTabs($event, 4)">
                  市州政协网站
                  <i class="el-icon-caret-top"></i>
                </div>
              </div>
            </div>
          </div>
        </el-main>
        <el-footer style="margin: 0;padding: 0;">
          <div @mouseout="closeLink">
            <Foot></Foot>
          </div>
        </el-footer>
      </el-container>
    </el-skeleton>
  </div>
</template>

<script>
import Head from '@/components/head.vue'
import Foot from '@/components/foot.vue'

export default {
  name: 'Home',
  components: {Head, Foot},
  data() {
    return {
      loading: true,
      newDetails: '/details',
      moveTabIndex: 0,
      moveLinkTabIndex: 0,
      pagesize: 8,
      showLink: false,
      linkTop: 0,
      tabList: [],
      c9headList: [],
      c9HotList: [],
      carouselList: [],
      c10HeadList: [],
      c10HotList: [],
      c11HotList: [],
      img1List: [],
      cid4List: [],
      c12List: [],
      c13List: [],
      c14List: [],
      cid6List: [],
      c23List: [],
      c15List: [[{img: ''}], [{img: ''}], [{img: ''}], [{img: ''}], [{img: ''}]],
      img2List: [],
      c27List: [],
      c28List: [],
      linkList: []
    }
  },
  created() {
    this.getList()
    this.getAsyncList()
  },
  methods: {
    getList() {
      const orderQuery = {
        orderBy: 'editTime desc,addTime desc',
        closeField: 'content,symbol,viewNum,href'
      }
      // C9-热点新闻-头条
      const c9HeadQuery = {
        pageIndex: 1,
        pageSize: 2,
        classId: 9,
        // 是否置顶
        headBool: true
      }
      this.$api.cms.apiCmsList(Object.assign(c9HeadQuery, orderQuery)).then(res => {
        this.c9headList = res.data
      })
      // C10-政协新闻-走马灯
      const carouselQuery = {
        pageIndex: 1,
        pageSize: 5,
        classId: 10,
        // 是否焦点
        focusBool: true,
        // 是否图片
        imgBoolc: true
      }
      this.$api.cms.apiCmsList(Object.assign(carouselQuery, orderQuery)).then(res => {
        this.carouselList = res.data
      })
      // C10-政协新闻-头条
      const c10HeadQuery = {
        pageIndex: 1,
        pageSize: 2,
        classId: 10,
        // 是否置顶
        headBool: true
      }
      this.$api.cms.apiCmsList(Object.assign(c10HeadQuery, orderQuery)).then(res => {
        this.c10HeadList = res.data
      })
      // C10-政协新闻-热点
      const c10HotQuery = {
        pageIndex: 1,
        pageSize: 3,
        classId: 10,
        // 是否热点
        hotBool: true
      }
      this.$api.cms.apiCmsList(Object.assign(c10HotQuery, orderQuery)).then(res => {
        this.c10HotList = res.data
        this.tabList = this.c10HotList
      })
      // C11-通知公告-热点
      const c11HotQuery = {
        pageIndex: 1,
        pageSize: 8,
        classId: 11
        // 是否热点
        // hotBool: true
      }
      this.$api.cms.apiCmsList(Object.assign(c11HotQuery, orderQuery)).then(res => {
        this.c11HotList = res.data
        this.loading = false
      })
      // C9-热点新闻
      const c9HotQuery = {
        pageIndex: 1,
        pageSize: 6,
        classId: 9,
        // 是否热点
        hotBool: true
      }
      this.$api.cms.apiCmsList(Object.assign(c9HotQuery, orderQuery)).then(res => {
        this.c9HotList = res.data
        this.loading = false
      })
    },
    async getAsyncList() {
      const orderQuery = {
        orderBy: 'editTime desc,addTime desc',
        closeField: 'content,symbol,viewNum,href'
      }
      // 图片管理-专栏图片
      this.$api.common.apiCommonImgList({ids: '1'}).then(res => {
        this.img1List = res.data[0].imageList
      })
      // 会议活动
      const cid4Query = {
        pageIndex: 1,
        pageSize: this.pagesize,
        cid: 4
      }
      this.$api.cms.apiCmsList(Object.assign(cid4Query, orderQuery)).then(res => {
        this.cid4List = res.data
      })
      // C12-机关建设
      const c12Query = {
        pageIndex: 1,
        pageSize: 8,
        classId: 12
      }
      this.$api.cms.apiCmsList(Object.assign(c12Query, orderQuery)).then(res => {
        this.c12List = res.data
        this.loading = false
      })
      // 县区政协
      const c13Query = {
        pageIndex: 1,
        pageSize: this.pagesize,
        classId: 13
      }
      this.$api.cms.apiCmsList(Object.assign(c13Query, orderQuery)).then(res => {
        this.c13List = res.data
      })
      // 党派团体
      const c14Query = {
        pageIndex: 1,
        pageSize: this.pagesize,
        classId: 14
      }
      this.$api.cms.apiCmsList(Object.assign(c14Query, orderQuery)).then(res => {
        this.c14List = res.data
      })
      // 学习园地
      const cid6Query = {
        pageIndex: 1,
        pageSize: this.pagesize,
        classId: 26
      }
      this.$api.cms.apiCmsList(Object.assign(cid6Query, orderQuery)).then(res => {
        this.cid6List = res.data
      })
      // 委员风采
      const c23Query = {
        pageIndex: 1,
        pageSize: this.pagesize,
        classId: 23
      }
      this.$api.cms.apiCmsList(Object.assign(c23Query, orderQuery)).then(res => {
        this.c23List = res.data
      })
      // 图片新闻
      const c15OrderQuery = {orderBy: 'hotBool desc,editTime desc,addTime desc'}
      const c15Query = {
        pageIndex: 1,
        pageSize: 5,
        classId: 15
      }
      this.$api.cms.apiCmsList(Object.assign(c15Query, c15OrderQuery)).then(res => {
        this.c15List = res.data
      })
      // 白银市政协智慧云平台
      this.$api.common.apiCommonImgList({ids: '2'}).then(res => {
        this.img2List = res.data[0].imageList
      })
      // 杂志
      const c27OrderQuery = {orderBy: 'hotBool desc,editTime desc,addTime desc'}
      const c27Query = {
        pageIndex: 1,
        pageSize: 8,
        classId: 27
      }
      this.$api.cms.apiCmsList(Object.assign(c27Query, c27OrderQuery)).then(res => {
        this.c27List = res.data
      })
      // 文史资料
      const c28OrderQuery = {orderBy: 'hotBool desc,editTime desc,addTime desc'}
      const c28Query = {
        pageIndex: 1,
        pageSize: 8,
        classId: 28
      }
      this.$api.cms.apiCmsList(Object.assign(c28Query, c28OrderQuery)).then(res => {
        this.c28List = res.data
      })

    },
    mousemoveTabs(v) {
      if (v === this.moveTabIndex) return
      this.moveTabIndex = v
      if (v === 0) {
        this.tabList = this.c10HotList
      } else if (v === 1) this.tabList = this.c9HotList
    },
    mousemoveLinkTabs(e, v) {
      if (v === this.moveLinkTabIndex) return
      console.log(666)
      let top1 = e.currentTarget.getBoundingClientRect().top
      let top2 = document.body.scrollTop || document.documentElement.scrollTop
      let top = top1 + top2
      this.moveLinkTabIndex = v
      // 友情链接
      this.$api.common.apiCommonBusinessitemGetByClassid({classid: v}).then(res => {
        this.linkList = res.data
        this.showLink = true
        let height = this.linkList.length / 4
        this.linkTop = top - Math.ceil(height) * 30
      })
    },//关闭友情链接
    closeLink() {
      this.showLink = false
      this.moveLinkTabIndex = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.headnew {
  position: relative;

  &.active {
    &::before {
      content: '';
      display: block;
      width: 60px;
      height: 60px;
      background-color: #c50000;
      position: absolute;
      right: 0px;
      top: 0px;
      z-index: 1;
      clip-path: polygon(100% 0, 0% 0%, 100% 100%);
    }

    &::after {
    }

    .cont {
      content: '';
      color: #ffffff;
      display: block;
      width: 60px;
      height: 60px;
      font-weight: bold;
      // border-right: #00aa00 solid 2px;
      // border-bottom: #00ff7f solid 2px;
      transform: rotate(45deg);
      position: absolute;
      right: -8px;
      top: 15px;
      z-index: 2;
    }
  }
}

.carousel-title {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 999999;
  width: 100%;
  opacity: 0.59;
  height: 40px;
  color: #fff;
  padding: 10px;
  overflow: hidden;
}

/* *表格背景透明 */
/* //透明化整体 */
.table-wrapper ::v-deep.el-table,
.el-table__expanded-cell {
  background-color: transparent !important;
}

/* //透明化行、单元格,删除表头下横线 */
.table-wrapper ::v-deep tr,
.table-wrapper ::v-deep th,
.table-wrapper ::v-deep td {
  // background: #1439391c !important;
  // color: #fff;
  border-bottom: 0px;
  /* //删除表头下横线 */
}

/* //hover时样式 */
.table-wrapper ::v-deep .el-table tbody tr:hover > td {
  background-color: #fff !important;
  color: #bf001a;
}

/* // 表格内容(有用) */
.table-wrapper ::v-deep .el-table__row {
  // background: #1439391c !important;
  color: #000;
}

/**表格背景透明end */
.table-wrapper > > > .el-table__row > td {
  /* 去除表格线 */
  border: none;
}

.table-wrapper > > > .el-table th.el-table__cell.is-leaf {
  /* 去除上边框 */
  border-bottom: none !important;
}

.table-wrapper > > > .el-table__inner-wrapper::before {
  /* 去除下边框 */
  height: 0;
}

.table-wrapper ::v-deep .el-table .el-table__cell {
  /* 高度 */
  padding: 0;
  height: 40px;
}

.table-wrapper ::v-deep .el-table::before {
  height: 0px;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.carousel-wrapper ::v-deep .el-carousel__item {
  background: none;
}

.carousel-wrapper ::v-deep .el-carousel__indicators--labels .el-carousel__button {
  font-size: 16px;
}

.t-link {
  position: absolute;
  z-index: 99;
  width: 100%;
  background-color: #757575;
}
</style>
